import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notFoundWidgetMonitoring" }
const _hoisted_2 = { class: "token-text-h5 ma-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Widget type not found : " + _toDisplayString(_ctx.widgetAPI.attributes.type), 1)
  ]))
}